import { FC } from "react";
import { motion } from "framer-motion";

import "./GridButton.css";

import { useCache } from "../utils/useCache";

interface GridButtonProps {
  className?: string;
  onClick?: () => void;
}

export const GridButton: FC<GridButtonProps> = ({ className, ...props }) => {
  const { nextStepAnimationSkip } = useCache();

  const hidden = {
    opacity: 0,
    width: "4rem",
    height: 0,
    rotate: 0,
    fontSize: "0rem"
  }

  const visible = {
    opacity: 1,
    width: "4rem",
    height: "4rem",
    rotate: 360,
    fontSize: "1.2rem"
  }

  return (
    <motion.button
      initial={nextStepAnimationSkip ? visible : hidden}
      animate={visible}
      transition={{
        duration: 0.01
      }}
      className={`grid-button ${className || ""}`}
      {...props}
    />
  )
}